import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import { Highlight } from '@tiptap/extension-highlight'
import { Underline } from '@tiptap/extension-underline'
import { TextAlign } from '@tiptap/extension-text-align'
import { Table } from '@tiptap/extension-table'
import { TableRow } from '@tiptap/extension-table-row'
import { TableCell } from '@tiptap/extension-table-cell'
import { TableHeader } from '@tiptap/extension-table-header'
import { Link } from '@tiptap/extension-link'
import { Image } from '@tiptap/extension-image'
import { Blockquote } from '@tiptap/extension-blockquote'


document.addEventListener('turbo:load', () => {
    const editorElement = document.getElementById('tiptap-editor')
    if (!editorElement) return

    const inputField = document.getElementById('term_body')

    const editor = new Editor({
        element: editorElement,
        extensions: [
            StarterKit.configure({ link: false, blockquote: false, underline: false }),
            TextStyle,
            Color,
            Highlight.configure({ multicolor: true }),
            Underline,
            TextAlign.configure({ types: ['heading', 'paragraph'] }),
            Table.configure({ resizable: true }),
            TableRow,
            TableCell,
            TableHeader,
            Link.configure({ openOnClick: false, autolink: false, linkOnPaste: true }),
            Blockquote,
            Image.configure({ allowBase64: true })
        ],
        content: inputField.value || '',
        onUpdate({ editor }) {
            inputField.value = editor.getHTML()
        }
    })

    editor.on('selectionUpdate', updateToolbar)
    editor.on('transaction', updateToolbar)

    // Dropdown intestazioni
    const headingBtn = document.getElementById('heading-dropdown-btn')
    const headingDropdown = document.getElementById('heading-dropdown')

    headingBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        const isOpen = headingDropdown.style.display === 'block'
        headingDropdown.style.display = isOpen ? 'none' : 'block'
        tableDropdown.style.display = 'none'
    })

    headingDropdown.addEventListener('click', (e) => {
        e.stopPropagation()
        const action = e.target.closest('[data-action]')?.dataset.action
        if (!action) return
        switch (action) {
            case 'h1': editor.chain().focus().toggleHeading({ level: 1 }).run(); break
            case 'h2': editor.chain().focus().toggleHeading({ level: 2 }).run(); break
            case 'h3': editor.chain().focus().toggleHeading({ level: 3 }).run(); break
            case 'h4': editor.chain().focus().toggleHeading({ level: 4 }).run(); break
            case 'h5': editor.chain().focus().toggleHeading({ level: 5 }).run(); break
            case 'h6': editor.chain().focus().toggleHeading({ level: 6 }).run(); break
        }
        headingDropdown.style.display = 'none'
    })

    // Dropdown tabella
    const tableBtn = document.getElementById('table-dropdown-btn')
    const tableDropdown = document.getElementById('table-dropdown')

    tableBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        const isOpen = tableDropdown.style.display === 'block'
        tableDropdown.style.display = isOpen ? 'none' : 'block'
        headingDropdown.style.display = 'none'
    })

    tableDropdown.addEventListener('click', (e) => {
        e.stopPropagation()
        const action = e.target.closest('[data-action]')?.dataset.action
        if (!action) return
        switch (action) {
            case 'insertTable': editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run(); break
            case 'addColumnBefore': editor.chain().focus().addColumnBefore().run(); break
            case 'addColumnAfter': editor.chain().focus().addColumnAfter().run(); break
            case 'deleteColumn': editor.chain().focus().deleteColumn().run(); break
            case 'addRowBefore': editor.chain().focus().addRowBefore().run(); break
            case 'addRowAfter': editor.chain().focus().addRowAfter().run(); break
            case 'deleteRow': editor.chain().focus().deleteRow().run(); break
            case 'deleteTable': editor.chain().focus().deleteTable().run(); break
        }
        tableDropdown.style.display = 'none'
    })

    // Chiusura dropdown cliccando fuori
    document.addEventListener('click', () => {
        headingDropdown.style.display = 'none'
        tableDropdown.style.display = 'none'
    })

    // TipTap Toolbar
    document.getElementById('tiptap-toolbar').addEventListener('click', (e) => {
        const action = e.target.closest('[data-action]')?.dataset.action
        if (!action) return

        switch (action) {
            case 'bold': editor.chain().focus().toggleBold().run(); break
            case 'italic': editor.chain().focus().toggleItalic().run(); break
            case 'underline': editor.chain().focus().toggleUnderline().run(); break
            case 'strike': editor.chain().focus().toggleStrike().run(); break
            case 'link' :
                const url = prompt('Inserisci URL')
                if (url && url.trim() !== '') {
                    editor.chain().focus().setLink({ href: url }).run()
                }
                break
            case 'unlink' : editor.chain().focus().unsetLink().run(); break
            case 'blockquote' : editor.chain().focus().toggleBlockquote().run(); break
            case 'codeBlock' : editor.chain().focus().toggleCodeBlock().run(); break
            case 'alignLeft': editor.chain().focus().setTextAlign('left').run(); break
            case 'alignCenter': editor.chain().focus().setTextAlign('center').run(); break
            case 'alignRight': editor.chain().focus().setTextAlign('right').run(); break
            case 'bulletList': editor.chain().focus().toggleBulletList().run(); break
            case 'orderedList': editor.chain().focus().toggleOrderedList().run(); break
            case 'image': document.getElementById('tiptap-image-input').click(); break
            case 'removeImage': editor.chain().focus().deleteSelection().run(); break
            case 'undo': editor.chain().focus().undo().run(); break
            case 'redo': editor.chain().focus().redo().run(); break
        }
    })

    //Caricamento immagine
    document.getElementById('tiptap-image-input').addEventListener('change', (e) => {
        const file = e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = (event) => {
            editor.chain().focus().setImage({ src: event.target.result }).run()
        }
        reader.readAsDataURL(file)
        e.target.value = ''
    })

    const boldButton = document.querySelector('[data-action="bold"]')
    const italicButton = document.querySelector('[data-action="italic"]')
    const underlineButton = document.querySelector('[data-action="underline"]')
    const strikeButton = document.querySelector('[data-action="strike"]')
    const alignLeftButton = document.querySelector('[data-action="alignLeft"]')
    const alignCenterButton = document.querySelector('[data-action="alignCenter"]')
    const alignRightButton = document.querySelector('[data-action="alignRight"]')
    const bulletListButton = document.querySelector('[data-action="bulletList"]')
    const orderedListButton = document.querySelector('[data-action="orderedList"]')
    const clearColorButton = document.querySelector('[data-action="clearColor"]')
    const linkButton = document.querySelector('[data-action="link"]')
    const blockquote = document.querySelector('[data-action="blockquote"]')
    const codeBlock = document.querySelector('[data-action="codeBlock"]')

    // Colore testo e evidenziazione
    let currentTextColor = '#000000'
    let currentHighlightColor = '#ffff00'

    const textColorInput = document.querySelector('[data-action="textColor"]')
    const highlightInput = document.querySelector('[data-action="highlight"]')

    textColorInput.addEventListener('input', (e) => {
        currentTextColor = e.target.value

        editor.chain().focus().setColor(currentTextColor).run()
    })

    highlightInput.addEventListener('input', (e) => {
        currentHighlightColor = e.target.value

        editor.chain().focus().setHighlight({ color: currentHighlightColor }).run()
    })

    //rimozione del colore del testo e dell'evidenziazione
    document.querySelector('[data-action="clearColor"]').addEventListener('click', () => {
        editor.chain().focus().unsetHighlight().unsetColor().run()

        textColorInput.value = currentTextColor
        highlightInput.value = currentHighlightColor
    })

    document.querySelector('[data-action="applyHighlight"]').addEventListener('click', (e) => {
        if (e.target.tagName !== 'INPUT') {
            editor.chain().focus().unsetHighlight().setHighlight({ color: currentHighlightColor }).run()
        }
    })

    //Aggiorna lo stato dell'editor TipTap
    function updateToolbar() {
        const alignment = editor.getAttributes('heading').textAlign ||
            editor.getAttributes('paragraph').textAlign || 'left'

        boldButton.classList.toggle('is-active', editor.isActive('bold'))
        italicButton.classList.toggle('is-active', editor.isActive('italic'))
        underlineButton.classList.toggle('is-active', editor.isActive('underline'))
        strikeButton.classList.toggle('is-active', editor.isActive('strike'))
        linkButton.classList.toggle('is-active', editor.isActive('link'))
        blockquote.classList.toggle('is-active', editor.isActive('blockquote'))
        codeBlock.classList.toggle('is-active', editor.isActive('codeBlock'))
        alignLeftButton.classList.toggle('is-active', alignment === 'left')
        alignCenterButton.classList.toggle('is-active', alignment === 'center')
        alignRightButton.classList.toggle('is-active', alignment === 'right')
        bulletListButton.classList.toggle('is-active', editor.isActive('bulletList'))
        orderedListButton.classList.toggle('is-active', editor.isActive('orderedList'))
        clearColorButton.classList.toggle('is-active', editor.isActive('clearColor'))

        updateColors()
        updateUndoRedoButton()
    }

    function updateColors() {
        const textColor = editor.getAttributes('textStyle').color
        const highlightColor = editor.getAttributes('highlight').color

        const fallbackText = '#000000'
        const fallbackHighlight = '#ffff00'

        currentTextColor = textColor || fallbackText
        currentHighlightColor = highlightColor || fallbackHighlight

        if (textColorInput.value !== currentTextColor) {
            textColorInput.value = currentTextColor
        }

        if (highlightInput.value !== currentHighlightColor) {
            highlightInput.value = currentHighlightColor
        }
    }

    function updateUndoRedoButton() {
        const undoButton = document.querySelector('[data-action="undo"]')
        const redoButton = document.querySelector('[data-action="redo"]')

        undoButton.disabled = !(editor.can().undo())
        redoButton.disabled = !(editor.can().redo())
    }
})